import React from 'react'
import { TouchableOpacity } from "react-native"
import Colors from '../../../constants/Colorsv2'
import { Text } from '../../../globalComponents/NativeOverrides'
import { MarketProps } from '../../../store/types/mk_svc'

type MarketLozengeProps = {
    market: MarketProps,
    is_active?:boolean,
    onSelect: (market:MarketProps) => void
}
export const MarketLozenge = ({ market, is_active, onSelect }:MarketLozengeProps) => {

    const handleSelect = () => {
        if(!onSelect){ return }
        onSelect(market)
    }
    
    return (
        <TouchableOpacity style={{ margin:4, borderWidth:1, borderColor:Colors.shades.shade400, backgroundColor:is_active?Colors.brand.midnight:Colors.shades.white, borderRadius:100, padding:10, paddingRight:20, paddingLeft:20 }} onPress={() => handleSelect()}>
            <Text size={16} color={is_active?Colors.shades.white:Colors.brand.midnight} weight='semibold'>{market.stat_label?market.stat_label:market.type}</Text>
        </TouchableOpacity>
    )
}

export default MarketLozenge